import React from 'react';

// Tiny pencil button used to open inline-edit modals on cards and rows.
// Renders an SVG inline so we don't have to add a new entry to Icon.tsx.

interface Props {
  onClick: () => void;
  ariaLabel?: string;
}

const EditPencil = ({ onClick, ariaLabel = 'Edit' }: Props) => (
  <button
    type="button"
    className="edit-pencil"
    aria-label={ariaLabel}
    onClick={(e) => {
      // Stop propagation so the surrounding card/row's own onClick doesn't fire.
      e.stopPropagation();
      onClick();
    }}
  >
    <svg
      width={14}
      height={14}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4z" />
    </svg>
  </button>
);

export default EditPencil;
